import { helper } from '@ember/component/helper';
import { formatPhone as formatter } from '@capital/intl/utils';

// Initially this helper was built using libphonenumber-js, which would handle
// e164 phone numbers. At some point when we need to support more than one
// country, this library should be added (and this helper maybe should be moved
// into `@capital/business-shared`), but until then we don't need to take the
// increased asset size.

export function formatPhone([phone], {
  uri = false
} = {}) {
  return formatter(phone, {
    uri
  });
}
export default helper(formatPhone);